/**
 * WordPress dependencies
 */
import {
	__experimentalVStack as VStack,
	__experimentalGrid as Grid,
	TabPanel,
	Spinner,
} from '@wordpress/components';
import { __ } from '@wordpress/i18n';
import { Fragment, useContext } from '@wordpress/element';
import Help from './help';
import { SettingsContext } from '../context/settings-context';
import { LoadingSpinner } from '../components/loading-spinner';
import SaveButton from '../components/save-button';

/**
 * Internal dependencies
 */
import { Header } from '../components/header';
import General from './general';
import Integrations from './integrations';
import Tools from './tools';
import Logs from './logs';
import { useLocation, useHistory } from '../router';

export const Settings = () => {
	const { params } = useLocation();
	const history = useHistory();
	const { settings } = useContext( SettingsContext );

	const changeTab = ( tabName ) => {
		history.push( { page: 'popper-settings', tab: tabName } );
	};

	if ( ! settings ) {
		return <LoadingSpinner text={ __( 'Loading...', 'popper' ) } />;
	}

	return (
		<Fragment>
			<Header title={ __( 'Settings' ) } />
			<div className="popper-content">
				<TabPanel
					initialTabName={ params.tab }
					onSelect={ ( tabName ) => changeTab( tabName ) }
					tabs={ [
						{
							name: 'general',
							title: 'Settings',
							component: General,
						},
						{
							name: 'integrations',
							title: 'Integrations',
							component: Integrations,
						},
						{
							name: 'tools',
							title: 'Tools',
							component: Tools,
						},
						{
							name: 'logs',
							title: 'Logs',
							component: Logs,
						},
					] }
				>
					{ ( tab ) => {
						const SettingsTab = tab.component;
						if ( 'logs' === tab.name ) {
							return <SettingsTab />
						}
						return (
							<Grid
								columns={ 4 }
								templateColumns="3fr 1fr"
								gap="4"
								align="flex-start"
								className="popper-settings"
							>
								<VStack>
									<SettingsTab />
									{ 'general' === tab.name && <SaveButton /> }
								</VStack>
								<VStack>
									<Help />
								</VStack>
							</Grid>
						);
					} }
				</TabPanel>
			</div>
		</Fragment>
	);
};
